
import PageInfo from "../../../services/entities/models/PageInfo";
export const getLandmarksSearchCtrls = () => {
  return {
    PageInfo: new PageInfo(null, null, "landmarkCode", "DESC"),
    landmarkCode: {
      id: "landmarkCode",
      elementType: "input",
      elementConfig: {
        name: "landmarkCode",
        type: "text",
        placeholder: "Landmark code",
      },
      validation: {
        required: false,
      },
      labelInput: {
        labeltext: "Landmark Code",
      },
      value: "",
      valid: false,
      touched: false,
      basicOrder: 1,
      advancedOrder:1 ,
    },
    name: {
      id: "name",
      elementType: "input",
      elementConfig: {
        name: "name",
        type: "text",
        placeholder: "Landmark name",
      },
      validation: {
        required: false,
      },
      labelInput: {
        labeltext: "Name",
      },
      value: "",
      valid: false,
      touched: false,
      basicOrder: 2,
      advancedOrder:2 ,
    },
    landmarkCategories: {
      id: "landmarkCategories",
      elementType: "select",
      elementConfig: {
        name: "landmarkCategories",
        options: [{ key: "", displayValue: "Select Category" }]
      },
      labelInput: {
        labeltext: "Category",
      },
      value: "",
      validation: {
        required: false,
      },
      valid: false,
      touched: false,
      basicOrder: 3,
      advancedOrder: 3,
    },
    locationCodes: {
      id: "locationCodes",
      elementType: "select",
      elementConfig: {
        name: "locationCodes",
        options: [{ key: "", displayValue: "Select Location" }],
      },
      labelInput: {
        labeltext: "Location",
      },
      value: "",
      validation: {
        required: false,
      },
      valid: false,
      touched: false,
      basicOrder: 4,
      advancedOrder: 4,
    },
    shortName: {
      id: "shortName",
      elementType: "input",
      elementConfig: {
        name: "shortName",
        type: "text",
        placeholder: "Symbol for map",
      },
      validation: {
        required: false,
      },
      labelInput: {
        labeltext: "Short Name",
      },
      value: "",
      valid: false,
      touched: false,
      basicOrder: 6,
      advancedOrder: 6,
    },
    status: {
      id: "status",
      elementType: "select",
      elementConfig: {
        name: "status",
        options: [{ key: "", displayValue: "All" }],
      },
      labelInput: {
        labeltext: "Status",
      },
      value: "",
      validation: {
        required: false,
      },
      valid: false,
      touched: false,
      basicOrder: 7,
      advancedOrder: 7,
    },
    formattedAddress: {
      id: "formattedAddress",
      elementType: "input",
      elementConfig: {
        name: "formattedAddress",
        type: "text",
        placeholder: "Landmark address",
      },
      validation: {
        required: false,
      },
      labelInput: {
        labeltext: "Address",
      },
      value: "",
      valid: false,
      touched: false,
      basicOrder: 8,
      advancedOrder:8 ,
    },
    empty: {
      id: "empty",
      elementType: "empty",
      elementConfig: {
        name: "",
        type: "empty",
      },
      basicOrder: 9,
      advancedOrder: 9,
    },
    btnResSearch: {
      id: "btnResSearch",
      elementType: "button",
      elementConfig: {
        type: "submit",
        value: "Search",
        name: "btnResSearch",
        className: "btn btn-primary search-btn",
      },
      basicOrder: 5,
      advancedOrder: 5,
    },
    btnResSearchReset: {
      id: "btnResSearchReset",
      elementType: "button",
      elementConfig: {
        type: "button",
        value: "Reset",
        name: "btnResSearchReset",
        className: "btn btn-secondary search-btn",
      },
      basicOrder: 10,
      advancedOrder: 10,
    },
  };
};
